import { createContext } from "react";
import { iTableConfigItem } from "./Table.helpers";
interface iTableContextData {
    config: iTableConfigItem[];
}

export const TableContext = createContext<iTableContextData>({
    config: [],
});